<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Admin' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>悬赏任务列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">会员编号：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入会员编号" style="width:400px;" v-model="subData.userId"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">标题：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入标题" style="width:400px;" v-model="subData.title"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">图片列表：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入图片列表" style="width:400px;" v-model="subData.imgPaths"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">圈子：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入圈子" style="width:400px;" v-model="subData.categoryIds"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">价格：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入价格" style="width:400px;" v-model="subData.price"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">下单时间：</el-text>
			<el-col :span="4">
				<el-date-picker v-model="subData.addDate" type="date" placeholder="选择日期"></el-date-picker>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">接单时间：</el-text>
			<el-col :span="4">
				<el-date-picker v-model="subData.jieDate" type="date" placeholder="选择日期"></el-date-picker>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">审核时间：</el-text>
			<el-col :span="4">
				<el-date-picker v-model="subData.applyDate" type="date" placeholder="选择日期"></el-date-picker>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">完成时间：</el-text>
			<el-col :span="4">
				<el-date-picker v-model="subData.complateDate" type="date" placeholder="选择日期"></el-date-picker>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">状态，0=待接单，1=待审核，2=已取消，3=进行中，4=已完成，：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入状态，0=待接单，1=待审核，2=已取消，3=进行中，4=已完成，" style="width:400px;" v-model="subData.state"></el-input>
			</el-col>
		</el-row>

      <el-row class="bt" style="padding:15px 0; padding-left: 100px;">
        <el-button type="primary" @click="submitEvent">确定</el-button>
        <el-button plain type="primary" @click="backEvent">返回</el-button>
      </el-row>
    </el-card>
  </div>
</template>

  
<script>

export default {
  data() {
    return {
      id: this.$route.query.id?this.$route.query.id:0,
      subData:{
		userId : '',
		title : '',
		imgPaths : '',
		categoryIds : '',
		price : '',
		addDate : '',
		jieDate : '',
		applyDate : '',
		complateDate : '',
		state : '',

      }
    }
  },
  mounted:function(){
    if(this.id>0){
      this.getData()
    }
  },
  methods: {
    backEvent(){
        this.$router.go(-1)
    },
    getData(){
      var ths = this
      ths.$get('/OfferRewards/queryById?id='+ths.id)
      .then(function (res) { 
          if(res.success){
            ths.subData = res.data
          }
      })
      .catch(function (err) {
        console.log(err)
      })    
    },
    submitEvent() {
      const ths = this;

      ths.$post('/OfferRewards/edit?', ths.subData)
        .then(function (res) { 
            alert(res.msg)
            if(res.success){
              ths.$router.push("/Admin/OfferRewardsList")
            }
        })
        .catch(function (err) {
          console.log(err)
        })      
      },
   }
}

</script>

<style>
.form-row{
  padding:15px 0; 
}
</style>